// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__27sfz","signatureButtonsRight":"ModalSign_signatureButtonsRight__372xF"};